import { isMeituanAppOrWebview } from '@nibfe/mkt-env-api';
const isMtAPP = isMeituanAppOrWebview();
export const evokeMtAappUrl = url => {
    const MTH5Url = 'https://w.dianping.com/cube/evoke/meituan.html?url=';
    return isMtAPP ? url : `${MTH5Url}${encodeURIComponent(url)}`;
};
export const handleParams = (params = {}) => {
    return Object.keys(params !== null && params !== void 0 ? params : {}).map(key => {
        const value = params[key];
        return value ? `&${key}=${value}` : '';
    }).join('');
};
